import useScreenSize from '../../../core/hooks/useScreenSize';
import { useExperienceDepressionContext } from '../../../core/context/ExperienceDepressionContext';
import Header from '../../../components/Header/Header';
import ExperienceHeader from '../../../components/ExperienceHeader/ExperienceHeader';
import ExperienceIframe from '../../../components/ExperienceIframe/ExperienceIframe';
import StoryList from '../../../components/StoryList/StoryList';
import StoryInfo from '../../../components/ScrollInfo/ScrollInfo';
import ExperienceInfo from '../../../components/ExperienceInfo/ExperienceInfo';
import {
  StyledPageContainer,
  StyledPageContent,
  StyledPageMainContent,
  StyledDividedPageContent,
} from '../../../styles/config/pageStyle';

function ExperienceDepressionPaul() {
  const {
    recommendedExperiences,
    recommendedHeading,
    infoContent,
    suggestedQuestions,
    iframeData,
  } = useExperienceDepressionContext();
  const [size] = useScreenSize();

  return (
    <>
      <Header title="Depression" isNavHidden />

      <StyledPageContainer>
        <StyledPageContent>
          <StyledPageMainContent>
            <StyledDividedPageContent>
              {size > 991 ? (
                <ExperienceInfo
                  infoContent={infoContent}
                  questions={suggestedQuestions}
                  experienceName="Depression"
                />
              ) : (
                <ExperienceHeader
                  menuComponent={
                    <StoryList
                      data={recommendedExperiences}
                      heading={recommendedHeading}
                      sidebar
                      mobileVertical
                    />
                  }
                  infoComponent={
                    <ExperienceInfo
                      infoContent={infoContent}
                      questions={suggestedQuestions}
                      experienceName="Depression"
                    />
                  }
                />
              )}
              <ExperienceIframe data={iframeData} />
            </StyledDividedPageContent>
            {size > 991 && (
              <>
                <StoryInfo data={{ title: 'Scroll down to see more' }} />
                <StoryList
                  data={recommendedExperiences}
                  heading={recommendedHeading}
                  border={false}
                />
              </>
            )}
          </StyledPageMainContent>
        </StyledPageContent>
      </StyledPageContainer>
    </>
  );
}

export default ExperienceDepressionPaul;
